<app-header-four [sticky]="true" [siteSettings]="settings"></app-header-four>
<router-outlet></router-outlet>
<!-- <app-newsletter></app-newsletter> -->
<app-footer-one *ngIf="environment.FooterComponentName=='app-footer-one'"
    [settings]="settings !== undefined?settings:''" [themeLogo]="settings !== undefined?settings.footerLogo:''">
</app-footer-one>
<app-footer-five *ngIf="environment.FooterComponentName=='app-footer-five'"
    [settings]="settings !== undefined?settings:''" [themeLogo]="settings !== undefined?settings.footerLogo:''">
</app-footer-five>